import { render, staticRenderFns } from "./StudentEvaluationHistoryAdd.vue?vue&type=template&id=03046485"
import script from "./StudentEvaluationHistoryAdd.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationHistoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports